<div (window:resize)="onResize($event)">
  <ng-content></ng-content>
</div>